import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { MailingHistoryPageInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-history-page.dto';
import type { MailingPageInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-page.dto';
import type { MailingFindManyQueryInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-find-many-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MailingService extends BaseService {
  protected baseUrl = '/basis/notification/mailing/mailing';

  public getRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(query?: MailingFindManyQueryInterface): Observable<MailingPageInterface> {
    return this.http.get<MailingPageInterface>(`${this.baseUrl}/items`, {
      params: query ? this.objectToHttpParams(query) : {}
    });
  }

  public run(queryParams: MailingFindManyQueryInterface): Observable<null> {
    return this.http.get<null>(`${this.baseUrl}/run`, { params: this.objectToHttpParams(queryParams) });
  }

  public runById(id: number): Observable<null> {
    return this.http.get<null>(`${this.baseUrl}/${id}/run`);
  }

  public historyById(id: number, queryParams: PaginationQueryInterface): Observable<MailingHistoryPageInterface> {
    return this.http.get<MailingHistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
